import { useMemo } from 'react'
import type { CustomerOrder } from '../customerOrdersApi'
import { formatCurrency, formatDateTime } from '../helpers/formatters'
import { toOrderStatusBadgeClasses, toOrderStatusLabel } from '../helpers/status'
import type { ShopLanguage, ShopLocale, ShopMessageKey } from '../../i18n'

type TranslateFn = (key: ShopMessageKey, params?: Record<string, string | number>) => string

export type CustomerOrderListItem = {
  id: string
  orderNumber: string
  createdAtLabel: string
  statusLabel: string
  statusBadgeClasses: string
  itemCount: number
  totalLabel: string
}

export const useCustomerOrderListItems = ({
  orders,
  language,
  locale,
  t,
}: {
  orders: CustomerOrder[]
  language: ShopLanguage
  locale: ShopLocale
  t: TranslateFn
}) =>
  useMemo<CustomerOrderListItem[]>(
    () =>
      orders.map((order) => ({
        id: order.id,
        orderNumber: order.orderNumber,
        createdAtLabel: t('customer.orders.createdAt', {
          date: formatDateTime(order.createdAt, locale, t('common.never')),
        }),
        statusLabel: toOrderStatusLabel(order.status, language),
        statusBadgeClasses: toOrderStatusBadgeClasses(order.status),
        itemCount: order.itemCount,
        totalLabel: formatCurrency(order.total, locale),
      })),
    [language, locale, orders, t],
  )
